<template>
  <div class="nuser-wrapper">
    <Title
      title="智慧照护"
      subTitle="Intelligent Care"
      @showMore="showMore"
    ></Title>
    <!-- 数字 -->
    <div class="count-con">
      <div class="count-item" v-for="item in count_data" :key="item.title">
        <div class="count-title">{{ item.title }}</div>
        <div class="num">{{ item.count }} <span class="unit">次</span></div>
      </div>
    </div>
    <div class="content">
      <div class="left-con">
        <div class="bed-code">
          <div class="title">一床一码（绑定/解绑）</div>
          <div class="num">
            {{ nurseData.bedCodeBind
            }}<span>/{{ nurseData.bedCodeUnBind }}</span>
          </div>
        </div>
        <div class="help-sos">
          <div class="title">紧急救助</div>
          <div class="num">{{ nurseData.bailout || 0 }} <span>次</span></div>
        </div>
      </div>
      <div class="right-con">
        <div class="chart-title">老人照护等级分布</div>
        <div id="nurse-chart"></div>
      </div>
    </div>
    <div class="line-chart-con">
      <div class="title-item">
        <div class="title-icon"></div>
        <div>照护服务统计</div>
      </div>
      <div id="line-chart"></div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/Title";
const echarts = require("echarts");
import roseChart from "./charts/care";
import lineChart from "./charts/line";
import pollingFunction from "@/utils/tools";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Title,
  },
  computed: {
    ...mapState(["nurseData"]),
  },
  data() {
    return {
      count_data: [
        {
          title: "能力评估",
          count: 0,
        },
        {
          title: "需求评估",
          count: 0,
        },
        {
          title: "照护计划",
          count: 0,
        },
        {
          title: "响应次数",
          count: 0,
        },
      ],
      level_data: [],
      service_data: {},
    };
  },
  async mounted() {
    //调用轮询;
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    await this.getData();
  },
  methods: {
    ...mapActions(["getNurseData"]),
    async getData() {
      await this.getNurseData({});
      this.$set(this.count_data[0], "count", this.nurseData.abilityEvaluate);
      this.$set(this.count_data[1], "count", this.nurseData.demandEvaluate);
      this.$set(this.count_data[2], "count", this.nurseData.takeCarePlanCount);
      this.$set(this.count_data[3], "count", this.nurseData.responseTimes);
      // 老人照护等级分布
      this.level_data = this.nurseData.elderNurseLevelList.map((item) => {
        return {
          value: item.num,
          name: item.levelName,
        };
      });
      // 服务照护统计
      this.service_data = {
        grqj: this.nurseData.takeCarePlan1,
        yzcl: this.nurseData.takeCarePlan2,
        yszl: this.nurseData.takeCarePlan3,
        qjzh: this.nurseData.takeCarePlan4,
        other: this.nurseData.takeCarePlan5,
      };

      this.drawChart();
    },
    showMore() {
      this.$store.commit("setDrawer", true);
      this.$store.commit("setCurrentMenu", "nurse");
    },
    drawChart() {
      this.nurseChart = echarts.init(document.getElementById("nurse-chart"));
      let nursrData = [
        {
          name: "专需护理",
          value: 469,
        },
        {
          name: "特三护理",
          value: 167,
        },
        {
          name: "特二护理",
          value: 183,
        },
        {
          name: "特一护理",
          value: 105,
        },
        {
          name: "一级护理",
          value: 582,
        },
        {
          name: "二级护理",
          value: 1531,
        },
        {
          name: "三级护理",
          value: 2,
        },
      ];
      this.nurseChart.setOption(roseChart(nursrData));
      this.lineChart = echarts.init(document.getElementById("line-chart"));

      this.lineChart.setOption(lineChart(this.service_data));
    },
  },
};
</script>

<style lang="scss" scoped>
.nuser-wrapper {
  width: 450px;
}
.count-con {
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  .count-item {
    color: #fff;
    .count-title {
      font-size: 14px;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
    }
    .num {
      font-size: 26px;
      font-weight: normal;
      letter-spacing: 0.02em;
      font-weight: bold;
      .unit {
        font-size: 15px;
        color: #ffffff;
        font-weight: normal;
      }
    }
  }
}
.content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: #fff;
  span {
    font-size: 15px;
  }
  .left-con {
    .num {
      font-size: 26px;
      font-weight: normal;
    }
    .bed-code {
      font-size: 14px;
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      margin-top: 10px;
    }
    .help-sos {
      font-size: 14px;
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      margin-top: 20px;
    }
  }
  .right-con {
    margin-top: 10px;
    width: 50%;
    .chart-title {
      font-size: 16px;
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 16px;
      writing-mode: horizontal-tb;
    }
    #nurse-chart {
      width: 100%;
      height: 160px;
    }
  }
}
.line-chart-con {
  .title-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    font-weight: normal;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 16px;
    writing-mode: horizontal-tb;
    .title-icon {
      width: 38px;
      height: 38px;
      border-radius: 5px;
      background-image: url("../../assets/index/fwtj.svg");
      mask: url("../../assets/index/fwtj.svg") no-repeat 50% 50%;
      -webkit-mask-size: cover;
      background-color: rgb(197, 255, 255);
      mask-size: cover;
      margin-right: 10px;
    }
  }
  #line-chart {
    width: 100%;
    height: 230px;
  }
}
</style>
